// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"172":"609cea18","508":"8f36341b","881":"839e9c3b"}[chunkId] + ".chunk.css";
};